export const orderTableHeader = [
    {key: 'id', label: 'id'},
    {key: 'createdAt', label: 'createdAt'},
    {key: 'status', label: 'status'},
    {key: 'total', label: 'total'},
    {key: 'user.firstName', label: 'userFirstName'},
    {key: 'user.lastName', label: 'userLastName'},
];